import React from "react";

interface FormNavigationProps {
  currentStep: number;
  totalSteps: number;
  onPrev: () => void;
  onNext: () => void;
  onSubmit: () => void;
  isLastStep: boolean;
  className?: string;
  hideBackButton?: boolean;
  isSubmitting?: boolean;
}

export function FormNavigation({
  currentStep,
  totalSteps,
  onPrev,
  onNext,
  onSubmit,
  isLastStep,
  className = "",
  hideBackButton = false,
  isSubmitting = false,
}: FormNavigationProps) {
  const isFirstStep = currentStep === 1;

  return (
    <div className={`flex justify-between mt-8 ${className}`}>
      {!hideBackButton && (
        <button
          type="button"
          onClick={onPrev}
          disabled={isFirstStep}
          className={`px-6 py-3 rounded-lg font-bold ${
            isFirstStep
              ? "bg-gray-bb-4 text-gray-bb-2 cursor-not-allowed"
              : "bg-gray-bb-1 text-white-bb hover:bg-gray-bb-2"
          }`}
        >
          VOLTAR
        </button>
      )}

      {!isLastStep ? (
        <button
          type="button"
          onClick={onNext}
          className="bg-yellow-bb text-blue-bb-3 px-6 py-3 rounded-lg font-bold hover:opacity-90 transition-all"
        >
          CONTINUAR
        </button>
      ) : (
        <button
          type="button"
          onClick={onSubmit}
          disabled={isSubmitting}
          className={`bg-yellow-bb text-blue-bb-3 px-6 py-3 rounded-lg font-bold transition-all ${
            isSubmitting ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-90'
          }`}
        >
          {isSubmitting ? 'ENVIANDO...' : 'FINALIZAR'}
        </button>
      )}
    </div>
  );
}